// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DebugModal_BlueprintUrl_Approval_Fragment = { __typename?: 'Approval', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_BidContract_Fragment = { __typename?: 'BidContract', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_BidContractRevision_Fragment = { __typename?: 'BidContractRevision', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_BidItem_Fragment = { __typename?: 'BidItem', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_BidPackageRequest_Fragment = { __typename?: 'BidPackageRequest', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Bill_Fragment = { __typename?: 'Bill', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_BusinessFunction_Fragment = { __typename?: 'BusinessFunction', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ChangeEvent_Fragment = { __typename?: 'ChangeEvent', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ChangeRequest_Fragment = { __typename?: 'ChangeRequest', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ChangeRequestToDo_Fragment = { __typename?: 'ChangeRequestToDo', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_SchedulePhase_Fragment = { __typename?: 'SchedulePhase', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ScheduleSubPhase_Fragment = { __typename?: 'ScheduleSubPhase', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Task_Fragment = { __typename?: 'Task', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ScheduleTask_Fragment = { __typename?: 'ScheduleTask', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_PlanTask_Fragment = { __typename?: 'PlanTask', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ToDo_Fragment = { __typename?: 'ToDo', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Invoice_Fragment = { __typename?: 'Invoice', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Region_Fragment = { __typename?: 'Region', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Market_Fragment = { __typename?: 'Market', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Community_Fragment = { __typename?: 'Community', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Subdivision_Fragment = { __typename?: 'Subdivision', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Lot_Fragment = { __typename?: 'Lot', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Structure_Fragment = { __typename?: 'Structure', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Unit_Fragment = { __typename?: 'Unit', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ProjectItem_Fragment = { __typename?: 'ProjectItem', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Estimate_Fragment = { __typename?: 'Estimate', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_DevelopmentCommitment_Fragment = { __typename?: 'DevelopmentCommitment', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Commitment_Fragment = { __typename?: 'Commitment', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Document_Fragment = { __typename?: 'Document', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_JobLogNote_Fragment = { __typename?: 'JobLogNote', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_TradePartnerAvailabilityRequest_Fragment = { __typename?: 'TradePartnerAvailabilityRequest', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_PunchlistItemTodo_Fragment = { __typename?: 'PunchlistItemTodo', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_WarrantyTicket_Fragment = { __typename?: 'WarrantyTicket', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_HomeownerContract_Fragment = { __typename?: 'HomeownerContract', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_HomeownerContractChangeOrder_Fragment = { __typename?: 'HomeownerContractChangeOrder', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_PlanPackage_Fragment = { __typename?: 'PlanPackage', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_GlobalOption_Fragment = { __typename?: 'GlobalOption', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ProjectCostCode_Fragment = { __typename?: 'ProjectCostCode', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_DesignPackage_Fragment = { __typename?: 'DesignPackage', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_Development_Fragment = { __typename?: 'Development', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_MaterialVariant_Fragment = { __typename?: 'MaterialVariant', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ProductOffering_Fragment = { __typename?: 'ProductOffering', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ProjectReadyPlanConfig_Fragment = { __typename?: 'ProjectReadyPlanConfig', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ProjectSiteCondition_Fragment = { __typename?: 'ProjectSiteCondition', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_ReadyPlanOption_Fragment = { __typename?: 'ReadyPlanOption', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrl_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_BlueprintUrlFragment = DebugModal_BlueprintUrl_Approval_Fragment | DebugModal_BlueprintUrl_BidContract_Fragment | DebugModal_BlueprintUrl_BidContractRevision_Fragment | DebugModal_BlueprintUrl_BidItem_Fragment | DebugModal_BlueprintUrl_BidPackageRequest_Fragment | DebugModal_BlueprintUrl_Bill_Fragment | DebugModal_BlueprintUrl_BusinessFunction_Fragment | DebugModal_BlueprintUrl_ChangeEvent_Fragment | DebugModal_BlueprintUrl_ChangeRequest_Fragment | DebugModal_BlueprintUrl_ChangeRequestToDo_Fragment | DebugModal_BlueprintUrl_SchedulePhase_Fragment | DebugModal_BlueprintUrl_ScheduleSubPhase_Fragment | DebugModal_BlueprintUrl_Task_Fragment | DebugModal_BlueprintUrl_ScheduleTask_Fragment | DebugModal_BlueprintUrl_PlanTask_Fragment | DebugModal_BlueprintUrl_ToDo_Fragment | DebugModal_BlueprintUrl_Invoice_Fragment | DebugModal_BlueprintUrl_StandaloneProject_Fragment | DebugModal_BlueprintUrl_Region_Fragment | DebugModal_BlueprintUrl_Market_Fragment | DebugModal_BlueprintUrl_Community_Fragment | DebugModal_BlueprintUrl_Subdivision_Fragment | DebugModal_BlueprintUrl_Lot_Fragment | DebugModal_BlueprintUrl_Structure_Fragment | DebugModal_BlueprintUrl_Unit_Fragment | DebugModal_BlueprintUrl_ProjectItem_Fragment | DebugModal_BlueprintUrl_Estimate_Fragment | DebugModal_BlueprintUrl_DevelopmentCommitment_Fragment | DebugModal_BlueprintUrl_Commitment_Fragment | DebugModal_BlueprintUrl_Document_Fragment | DebugModal_BlueprintUrl_ItemTemplateItemVersion_Fragment | DebugModal_BlueprintUrl_JobLogNote_Fragment | DebugModal_BlueprintUrl_TradePartnerAvailabilityRequest_Fragment | DebugModal_BlueprintUrl_PunchlistItemTodo_Fragment | DebugModal_BlueprintUrl_WarrantyTicket_Fragment | DebugModal_BlueprintUrl_HomeownerContract_Fragment | DebugModal_BlueprintUrl_HomeownerContractChangeOrder_Fragment | DebugModal_BlueprintUrl_ReadyPlan_Fragment | DebugModal_BlueprintUrl_PlanPackage_Fragment | DebugModal_BlueprintUrl_GlobalOption_Fragment | DebugModal_BlueprintUrl_ProjectCostCode_Fragment | DebugModal_BlueprintUrl_CommitmentChangeOrder_Fragment | DebugModal_BlueprintUrl_DesignPackage_Fragment | DebugModal_BlueprintUrl_Development_Fragment | DebugModal_BlueprintUrl_ItemTemplateItem_Fragment | DebugModal_BlueprintUrl_MaterialVariant_Fragment | DebugModal_BlueprintUrl_ProductOffering_Fragment | DebugModal_BlueprintUrl_ProjectReadyPlanConfig_Fragment | DebugModal_BlueprintUrl_ProjectSiteCondition_Fragment | DebugModal_BlueprintUrl_ReadyPlanOption_Fragment | DebugModal_BlueprintUrl_TakeoffLineItem_Fragment | DebugModal_BlueprintUrl_TakeoffLineItemVersion_Fragment;

export type DebugModal_VersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } };

export type DebugModal_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, name: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, planPackage: { __typename?: 'PlanPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, blueprintUrl: { __typename?: 'Url', url: string } };

export type DebugModal_LoadQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DebugModal_LoadQuery = { __typename?: 'Query', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, status: Types.CheckoutConfigStatus, pricingTraceUrl?: { __typename?: 'Url', url: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, name: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, planPackage: { __typename?: 'PlanPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, blueprintUrl: { __typename?: 'Url', url: string } } | null | undefined, aduAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, name: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, planPackage: { __typename?: 'PlanPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } }, blueprintUrl: { __typename?: 'Url', url: string } } | null | undefined, structure: { __typename?: 'Structure', id: string, name: string, blueprintUrl: { __typename?: 'Url', url: string } } } };

export type DebugModal_SyncToVersionMutationVariables = Types.Exact<{
  input: Types.SyncCheckoutConfigToVersionInput;
}>;


export type DebugModal_SyncToVersionMutation = { __typename?: 'Mutation', syncCheckoutConfigToVersion: { __typename?: 'SaveCheckoutConfigResult', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, aduAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined } } };

export const DebugModal_BlueprintUrlFragmentDoc = gql`
    fragment DebugModal_BlueprintUrl on HasBlueprintUrl {
  blueprintUrl {
    url
  }
}
    `;
export const DebugModal_VersionFragmentDoc = gql`
    fragment DebugModal_Version on ReadyPlanAggregateVersion {
  id
  version
  promotedAt
  promotedBy {
    id
    name
  }
  status {
    code
  }
}
    `;
export const DebugModal_ProductOfferingFragmentDoc = gql`
    fragment DebugModal_ProductOffering on ProductOffering {
  id
  name
  ...DebugModal_BlueprintUrl
  aggregateCheckout {
    id
  }
  aggregateVersions {
    ...DebugModal_Version
  }
  planPackage {
    id
    name
    ...DebugModal_BlueprintUrl
  }
  interiorDesignPackage {
    id
    name
    ...DebugModal_BlueprintUrl
  }
  exteriorDesignPackage {
    id
    name
    ...DebugModal_BlueprintUrl
  }
}
    ${DebugModal_BlueprintUrlFragmentDoc}
${DebugModal_VersionFragmentDoc}`;
export const DebugModal_LoadDocument = gql`
    query DebugModal_Load($id: ID!) {
  checkoutConfig(id: $id) {
    id
    status
    pricingTraceUrl {
      url
    }
    aggregateVersion {
      ...DebugModal_Version
    }
    productOffering {
      ...DebugModal_ProductOffering
    }
    aduAggregateVersion {
      ...DebugModal_Version
    }
    aduProductOffering {
      ...DebugModal_ProductOffering
    }
    structure {
      id
      name
      ...DebugModal_BlueprintUrl
    }
  }
}
    ${DebugModal_VersionFragmentDoc}
${DebugModal_ProductOfferingFragmentDoc}
${DebugModal_BlueprintUrlFragmentDoc}`;

/**
 * __useDebugModal_LoadQuery__
 *
 * To run a query within a React component, call `useDebugModal_LoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebugModal_LoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebugModal_LoadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDebugModal_LoadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DebugModal_LoadQuery, DebugModal_LoadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DebugModal_LoadQuery, DebugModal_LoadQueryVariables>(DebugModal_LoadDocument, options);
      }
export function useDebugModal_LoadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DebugModal_LoadQuery, DebugModal_LoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DebugModal_LoadQuery, DebugModal_LoadQueryVariables>(DebugModal_LoadDocument, options);
        }
export type DebugModal_LoadQueryHookResult = ReturnType<typeof useDebugModal_LoadQuery>;
export type DebugModal_LoadLazyQueryHookResult = ReturnType<typeof useDebugModal_LoadLazyQuery>;
export type DebugModal_LoadQueryResult = Apollo.QueryResult<DebugModal_LoadQuery, DebugModal_LoadQueryVariables>;
export const DebugModal_SyncToVersionDocument = gql`
    mutation DebugModal_SyncToVersion($input: SyncCheckoutConfigToVersionInput!) {
  syncCheckoutConfigToVersion(input: $input) {
    checkoutConfig {
      id
      aggregateVersion {
        ...DebugModal_Version
      }
      aduAggregateVersion {
        ...DebugModal_Version
      }
    }
  }
}
    ${DebugModal_VersionFragmentDoc}`;
export type DebugModal_SyncToVersionMutationFn = Apollo.MutationFunction<DebugModal_SyncToVersionMutation, DebugModal_SyncToVersionMutationVariables>;

/**
 * __useDebugModal_SyncToVersionMutation__
 *
 * To run a mutation, you first call `useDebugModal_SyncToVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDebugModal_SyncToVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [debugModalSyncToVersionMutation, { data, loading, error }] = useDebugModal_SyncToVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDebugModal_SyncToVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DebugModal_SyncToVersionMutation, DebugModal_SyncToVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DebugModal_SyncToVersionMutation, DebugModal_SyncToVersionMutationVariables>(DebugModal_SyncToVersionDocument, options);
      }
export type DebugModal_SyncToVersionMutationHookResult = ReturnType<typeof useDebugModal_SyncToVersionMutation>;
export type DebugModal_SyncToVersionMutationResult = Apollo.MutationResult<DebugModal_SyncToVersionMutation>;
export type DebugModal_SyncToVersionMutationOptions = Apollo.BaseMutationOptions<DebugModal_SyncToVersionMutation, DebugModal_SyncToVersionMutationVariables>;